import { forwardRef } from 'react';
import { Skeleton as RadixSkeleton } from '@radix-ui/themes';
import type { RadixSkeletonProps } from '@/types/radix-ui';

/**
 * Skeleton component - wrapper around Radix UI Skeleton
 * Provides loading state placeholders for content
 */
export type SkeletonProps = RadixSkeletonProps;

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>((props, ref) => {
  return <RadixSkeleton ref={ref} {...props} />;
});

Skeleton.displayName = 'Skeleton';

export { Skeleton };
